export const selectJiraIssueDetails = (state) => state.jiraIssueDetails;
